import React, { useEffect } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { styled } from '@mui/material/styles';

const CarouselContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const CarouselImage = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
});

const CarouselControls = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const PrintingCounter = styled(Typography)({
  position: 'absolute',
  bottom: '0%',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  padding: '2px 6px',
  fontSize: '20px',
  borderRadius: '4px',
});

const PrintingCounterPhone = styled(Typography)({
  position: 'absolute',
  bottom: '-2%',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  padding: '2px 6px',
  fontSize: '12px',
  borderRadius: '4px',
});

const ImageCarousel = ({ imageStyle, imageUrls, setSelectedCardIndex, selectedCardIndex, setLink, phone}) => {
  const goToPrevious = () => {
        setSelectedCardIndex((prevIndex) => 
          prevIndex === 0 ? imageUrls.length - 1 : prevIndex - 1
      );
  };

  const goToNext = () => {
        setSelectedCardIndex((prevIndex) => 
          prevIndex === imageUrls.length - 1 ? 0 : prevIndex + 1
      );
  };

  useEffect(() => {
    fetch(`https://api.scryfall.com/cards/${imageUrls[selectedCardIndex].split('/').at(-1).replace('.jpg', '')}`).then((t) => t.json()).then((k) => setLink(k.scryfall_uri)).catch((t) => console.log(t));
  }, [selectedCardIndex, imageUrls, setLink])

  return (
      <CarouselContainer >
          <CarouselImage
              style={imageStyle}
              alt={`Image ${selectedCardIndex + 1}`}
              src={imageUrls[selectedCardIndex]}
          />
          {imageUrls.length > 1 && (
              <CarouselControls>
                  <IconButton
                      onClick={goToPrevious}
                      sx={{
                          backgroundColor: 'rgba(255, 255, 255, 0.5)',
                          '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.8)' },
                      }}
                  >
                      <ArrowBackIosNewIcon />
                  </IconButton>
                  <IconButton
                      onClick={goToNext}
                      sx={{
                          backgroundColor: 'rgba(255, 255, 255, 0.5)',
                          '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.8)' },
                      }}
                  >
                      <ArrowForwardIosIcon />
                  </IconButton>
              </CarouselControls>
          )}
          {phone ? 
          <PrintingCounterPhone>
              Printing: {selectedCardIndex + 1}/{imageUrls.length}
          </PrintingCounterPhone>
          : 
          <PrintingCounter>
              Printing: {selectedCardIndex + 1}/{imageUrls.length}
          </PrintingCounter>
          }
      </CarouselContainer>
  );
};

export default ImageCarousel;